module.exports = __webpack_public_path__ + "img/slash.04087f40.svg";